import React from "react";
import { useTable, useGlobalFilter, usePagination, useSortBy } from "react-table";

const DataTableLogic = (tableColumns, tableData, hiddenColumns = []) => {
  const columns = React.useMemo(() => tableColumns, [tableColumns]);
  const data = React.useMemo(() => (tableData ? tableData : []), [tableData]);
  const pageSizeList = [10, 25, 50, 100, 250, 500];

  const {
    getTableProps,
    getTableBodyProps,
    prepareRow,
    headerGroups,
    page,
    state,
    setGlobalFilter,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        hiddenColumns: hiddenColumns,
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { globalFilter, pageIndex, pageSize } = state;

  const startEntry = pageIndex * pageSize + 1;

  return {
    headerGroups,
    page,
    globalFilter,
    setGlobalFilter,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    startEntry,
    pageSizeList,
    pageSize,
    setPageSize,
    getTableProps,
    getTableBodyProps,
    prepareRow,
  };
};

export default DataTableLogic;
